import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../../lib/api";
import { fmtAmt, fmtLeft } from "../../lib/competition";
import { useMarketSummary } from "../../lib/market";
import { fmtUsd } from "../../lib/format";
import { TokenLogo } from "../TokenSelect";
import { fileUrl } from "../TokenPageCustomize";
import { SectionHead } from "./HomeHero";

const Card = ({ c, m, dup }) => {
  const t = c.token_info || {};
  const started = c.start_ts <= Date.now() / 1000;
  return (
    <div data-testid={dup ? undefined : `comp-showcase-card-${c.id}`} aria-hidden={dup || undefined} className="mx-2 w-[280px] flex-none rounded-xl border border-white/10 bg-[#0b0d11]/95 p-5 backdrop-blur-md transition-colors hover:border-lime/50 sm:w-[310px]">
      <div className="flex items-center gap-3">
        <TokenLogo t={{ symbol: t.symbol, address: c.token, logo: fileUrl(t.logo) || m?.logo }} size={40} />
        <div className="min-w-0">
          <p className="truncate font-semibold text-white">{t.name}</p>
          <p className="font-mono text-xs text-lime">${t.symbol}</p>
        </div>
        {started ? <span className="ml-auto inline-flex items-center gap-1.5 rounded-full border border-lime/30 bg-lime/10 px-2 py-0.5 text-[10px] font-bold text-lime"><span className="h-1.5 w-1.5 animate-pulse rounded-full bg-lime" /> LIVE</span>
          : <span className="ml-auto rounded-full border border-sky-400/40 bg-sky-400/10 px-2 py-0.5 text-[10px] font-bold text-sky-300">SOON</span>}
      </div>
      <div className="mt-4 grid grid-cols-2 gap-2 text-xs">
        <div><p className="text-slate-500">Price</p><p className="font-mono text-white" data-testid={dup ? undefined : `comp-showcase-price-${c.id}`}>{m?.available ? fmtUsd(m.price_usd) : "—"}</p></div>
        <div><p className="text-slate-500">{started ? "Ends in" : "Starts in"}</p><p className="font-mono text-white">{fmtLeft((started ? c.end_ts : c.start_ts) - Date.now() / 1000)}</p></div>
        <div className="col-span-2"><p className="text-slate-500">Prize pot</p><p className="truncate font-mono text-lime">{fmtAmt(c.funded_amount || c.reward_amount, t.decimals)} {t.symbol} · top {c.winners}</p></div>
      </div>
      <Link to={`/token/${c.token}#competition`} tabIndex={dup ? -1 : undefined} data-testid={dup ? undefined : `comp-showcase-view-${c.id}`} className="mt-4 block w-full rounded-lg bg-white/5 py-2 text-center text-sm font-semibold text-white transition-colors hover:bg-lime hover:text-black">View competition</Link>
    </div>
  );
};

export const CompetitionShowcase = () => {
  const [list, setList] = useState(null);
  const [, tick] = useState(0);
  useEffect(() => {
    const load = () => api.get("/competitions/active").then((r) => setList(r.data.competitions)).catch(() => setList((l) => l || []));
    load();
    const a = setInterval(load, 60000), b = setInterval(() => tick((x) => x + 1), 1000);
    return () => { clearInterval(a); clearInterval(b); };
  }, []);
  const now = Date.now() / 1000;
  const live = (list || []).filter((c) => c.end_ts > now).sort((a, b) => (a.start_ts <= now) === (b.start_ts <= now) ? a.end_ts - b.end_ts : a.start_ts <= now ? -1 : 1);
  const mkt = useMarketSummary(live.map((c) => c.token));
  const loop = live.length ? Array.from({ length: Math.max(2, Math.ceil(8 / live.length)) }, () => live).flat() : [];
  if (!live.length) return null;
  return (
    <section data-testid="competition-showcase" className="fade-up">
      <SectionHead id="competitions" title={live.some((c) => c.start_ts <= now) ? "Live trading competitions" : "Upcoming trading competitions"} right={<span className="text-xs text-slate-500">Trade on a token's page to climb its leaderboard</span>} />
      {(
        <div className="-mx-3 overflow-x-auto pb-2 [scrollbar-width:none] sm:overflow-hidden" data-testid="competition-showcase-track">
          <div className="comp-marquee flex py-1">{loop.map((c, i) => <Card key={`${c.id}-${i}`} c={c} m={mkt[c.token]} dup={i >= live.length} />)}</div>
        </div>
      )}
    </section>
  );
};
